import {
  ODataHeader,
  ODataString,
  ODataEnum,
} from "pbas-vue-components";
import { i18n } from '@/plugins/i18n';

function getHeaders(enums) {
  const headers = [
    new ODataHeader({
      type: new ODataString("PlanId"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false
    }),
    new ODataHeader({
      title: "globals.plan",
      type: new ODataString("Number"),
      sortable: true,
      visible: true,
      searchable: true
    }),
    new ODataHeader({
      title: "headers.plan_guides_assignments.fee_guide_province",
      type: new ODataEnum("ClaimSettings/FeeGuideProvince", {
        getString: (item) => {
          if (item.ClaimSettings===null || item.ClaimSettings === undefined) {
            return "";
          }
          return i18n.t("enums." + item.ClaimSettings.FeeGuideProvince);
        },
        dropdownItems: enums.PaymentMethod,
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
  ];
  return headers;
}
export default getHeaders;
